// Fechas LOCALES para la UI (fix 3-jul, bug #16 de Karla):
// - NUNCA usar new Date().toISOString().slice(0,10) para "hoy": es UTC, y en Mexicali
//   (UTC-7) desde las 5pm devuelve MAÑANA → en fin de mes la vista "Mes" anclaba en el
//   mes siguiente (vacío) y los gastos recién registrados "no salían en el mensual".
// - Sumar meses con setMonth() desborda en días 29-31 (31-may +1 mes = 1-jul, se salta
//   junio al navegar ← →): aquí se suma con el día ACOTADO al último día del mes destino.

export function toISO(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** Hoy en hora LOCAL del navegador, 'YYYY-MM-DD'. */
export function todayLocal(): string {
  return toISO(new Date());
}

export function fromISO(iso: string): Date {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/** Suma meses a una fecha ISO acotando el día al último del mes destino (31-ene +1 → 28-feb). */
export function addMonthsClamped(iso: string, delta: number): string {
  const d = fromISO(iso);
  const day = d.getDate();
  d.setDate(1);
  d.setMonth(d.getMonth() + delta);
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  d.setDate(Math.min(day, last));
  return toISO(d);
}
